import React from 'react';
import Typewriter from 'typewriter-effect';

const Typing = () => {
  return (
    <Typewriter
      options={{
        strings: [
          'Senior Fullstack Engineer',
          'Machine Learning / NLP Engineer',
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
};

export default Typing;
